import {Link, PageProps, graphql} from 'gatsby'
import React, {useEffect, useState} from 'react'

import ClientCard from '../components/projects/ClientCard'
import Layout from '../components/ui/layout'
import {MDXProvider} from '@mdx-js/react'
import {MDXRenderer} from 'gatsby-plugin-mdx'
import ProjectList from '../components/projects/ProjectList'
import SEO from '../components/shared/seo'
import posed from 'react-pose'
import styled from 'styled-components'
import {useLayoutValue} from '../components/ui/layoutProvider'
import {useMediaQuery} from 'react-responsive'
import LogoGit from '../images/svgs/social/github.svg'

const Work: React.FC<PageProps<any>> = ({data, ...props}) => {
  const {state, dispatch} = useLayoutValue()
  const isMobile = useMediaQuery({maxWidth: 1224})

  return (
    <>
      <SEO
        title="Projects | John Dore"
        keywords={[`Computational Art`, `T1`, `John Dore`, `Plotter Drawings`]}
      />
      <div className=" text-white w-full bg-gray tracking-widest">
        <div className="mx-8 md:mx-10 text-5xl text-white md:text-7xl pt-20 leading-header font-normal text-3xl">
          dev
        </div>
      </div>
      <main className="flex flex-col mb-24 ">
        <div className="md:p-0 text-xs md:w-1/2 w-full md:m-10 p-8 mb-10">
          <div className=" text-left  text-base md:text-xl">
           Hi i'm aj,
          </div>
          <div className=" text-left  text-base md:text-lg">
          <br></br>To pay for things in this life I work as a developer.<br></br> I am currently based in London.<br></br>
           My <a className="hover:underline" href="https://github.com/ajdorexyz" target="_blank">GitHub</a> currently consists of private repos but maybe that will change in the future.<br></br>Currently in my spare time, i'm learning Rust. 
          </div>
          <div className=" text-left  text-base md:text-xl">
          </div>
          {/* <Divider
            className="mb-4"
            style={{opacity: opacity.interpolate((o) => 1 - o), width}}></Divider> */}
          {/* <div className="flex  flex-row flex-wrap items-center my-2 ">
            <a className="h-8 w-12 " href="https://github.com/ajdorexyz" target="_blank">
              <LogoGit className="w-12 h-8" />
            </a>
          </div> */}
        </div>
        <div className="text-3xl md:text-2xl  mx-8 md:mx-10 leading-header text-black mt-10">
          2021-Present
        </div>
        <div className="w-screen border-b border-black mb-10"></div>
        <div className=" text-left text-base md:text-xl md:m-10">
           Full Stack Engineer @ <a className="hover:underline" href="https://artlogic.net/" target='_blank'>Artlogic</a>
        </div>
        <div className="text-3xl md:text-2xl  mx-8 md:mx-10 leading-header text-black mt-10">
          2020-2021
        </div>
        {/* divider */}
        <div className="w-screen border-b border-black mb-10"></div>
        <div className="flex flex-row  flex-wrap mx-8 md:mx-10 w-full relative ">
          {data.clients.edges.map((client) => {
            return (
              <div className="">
                <ClientCard
                  date={client.node.date}
                  role={client.node.role}
                  image_1={client.node.image1.childImageSharp.fluid}
                  // image_2={client.node.image2.childImageSharp.fluid}
                  link={client.node.link}
                  tags={client.node.tags}
                  description={client.node.description}
                  title={client.node.title}></ClientCard>
              </div>
            )
          })}
        </div>
        {/* <div className="text-3xl md:text-4xl text-black mx-8 md:mx-10 leading-header mt-16 ">
          art
        </div>
        <div className="w-screen border-b border-black mb-8"></div>
        <div className="px-8 md:px-0 md:mx-10 md:w-3/4 w-full ">
          {data.art.edges.map((project) => (
            <>
              <ProjectList data={props} project={project}></ProjectList>
            </>
          ))}
        </div> */}
      </main>
    </>
  )
}

// TODO: remove remnants of image2 from this component and the json data
export const query = graphql`
  {
    art: allMdx(sort: {order: DESC, fields: frontmatter___date}) {
      edges {
        node {
          id
          body
          excerpt
          slug
          frontmatter {
            title
            date
            excerpt
          }
        }
      }
    }
    clients: allClientsJson(filter: {}) {
      edges {
        node {
          image1 {
            id
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
              original {
                src
              }
            }
            sourceInstanceName
          }

          date
          description
          role
          title
          link
          technology
          tags
        }
      }
    }
  }
`

export default Work
